var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 9.64286H5.34375C4.03193 9.64286 2.96875 10.6679 2.96875 11.9329V14.21C2.96875 15.4746 4.03193 16.5 5.34375 16.5H5.9375C6.59322 16.5 7.125 15.9871 7.125 15.355V10.7879C7.125 10.1554 6.59322 9.64286 5.9375 9.64286ZM13.6562 9.64286H13.0625C12.4068 9.64286 11.875 10.1554 11.875 10.7879V15.355C11.875 15.9871 12.4068 16.5 13.0625 16.5H13.6562C14.9681 16.5 16.0312 15.4746 16.0312 14.21V11.9329C16.0312 10.6682 14.9681 9.64286 13.6562 9.64286ZM9.5 0.5C4.19002 0.5 0.16959 4.75464 0 9.64286V13.6429C0 13.9586 0.265703 14.2143 0.59375 14.2143H1.1875C1.51555 14.2143 1.78125 13.9586 1.78125 13.6429V9.64286C1.78125 5.5475 5.24467 2.22143 9.5 2.22071C13.7553 2.22143 17.2188 5.5475 17.2188 9.64286V13.6429C17.2188 13.9586 17.4845 14.2143 17.8125 14.2143H18.4062C18.7343 14.2143 19 13.9586 19 13.6429V9.64286C18.8304 4.75464 14.81 0.5 9.5 0.5Z",
    fill: "#8A92A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.b4728d847786dd360d012ec608e57c35.svg";
export { ForwardRef as ReactComponent };